//**************************************************************************************************
//  ヘッダー
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';

import { TranslateService, TranslatePipe } from "@ngx-translate/core";

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

import { PushmessageFireService } from '../../function/pushmessage/pushmessage-service/pushmessage-fire';

import { SessionService } from '../services/session-service';
import { Session }  from '../../class/session';

import { FireSysAdmin } from '../models/fire/sys_admin';
import { FireLeAdmin } from '../models/fire/le_admin';
import { FireLeUser } from '../models/fire/le_user';
import { FireEventInfo } from '../models/fire/event_info';
import { FireEventShow } from '../models/fire/event_show';
import { FireReserveInfo } from '../models/fire/reserve_info';
import { FireMasterAuthenticationKey } from '../models/fire/master_authentication_key';
//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    TranslatePipe,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
  ],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
//==================================================================================================
//  class
//==================================================================================================
export class Header {
  //================================================================================================
  //  @ViewChild  （HTML内の要素との紐付けを宣言）
  //================================================================================================
  @Output() sidenavClose        = new EventEmitter();
  @Output() sidenavToggle       = new EventEmitter();
  //================================================================================================
  //  変数定義
  //================================================================================================
  isLogin                       : boolean                 = false;                                  //  ログイン
  isAuthSA                      : boolean                 = false;                                  //  システム管理者
  isAuthLA                      : boolean                 = false;                                  //  LE管理者
  isAuthLU                      : boolean                 = false;                                  //  LEユーザー
  isEventInfo                   : boolean                 = false;                                  //  興行
  isEventShow                   : boolean                 = false;                                  //  開催
  isReserveInfo                 : boolean                 = false;                                  //  予約
  isMasterAuthenticationKey     : boolean                 = false;                                  //  認証キーマスタ
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionLeAdmin                : FireLeAdmin | null      = null;                                   //  セッション情報：LE管理者
  sessionLeUser                 : FireLeUser | null       = null;                                   //  セッション情報：LEユーザー
  sessionEventInfo              : FireEventInfo | null    = null;                                   //  セッション情報：興行
  sessionEventShow              : FireEventShow | null    = null;                                   //  セッション情報：開催
  sessionReserveInfo            : FireReserveInfo | null  = null;                                   //  セッション情報：予約
  sessionMasterAuthenticationKey: FireMasterAuthenticationKey | null = null;                        //  セッション情報：認証キーマスタ
  //------------------------------------------------------------------------------------------------
  ssPushmessage                 = new Subscription();
  ssPushmessage_flag            = false;
  //------------------------------------------------------------------------------------------------
  private configSucces          : MatSnackBarConfig = {
    panelClass                    : ['style-succes'],
  };
  private configWarning         : MatSnackBarConfig = {
    panelClass                    : ['style-warning'],
  };
  private configError           : MatSnackBarConfig = {
    panelClass                    : ['style-error'],
  };
  currentLang                   : string                  = "日本語"
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(
    private sessionService: SessionService,
    private pushmessageFireService: PushmessageFireService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    //----------------------------------------------------------------------------------------------
    if (this.translate.currentLang == 'en') {
      this.currentLang = "English";
    } else {
      this.currentLang = "日本語";
    }
    //----------------------------------------------------------------------------------------------
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin            = session.isLogin;
        this.sessionUid         = session.uid;
        this.sessionSysAdmin    = session.sysAdmin;
        this.sessionLeAdmin     = session.leAdmin;
        this.sessionLeUser      = session.leUser;
        this.sessionEventInfo   = session.eventInfo;
        this.sessionEventShow   = session.eventShow;
        this.sessionReserveInfo = session.reserveInfo;
        this.sessionMasterAuthenticationKey = session.masterAuthenticationKey;
        //------------------------------------------------------------------------------------------
        this.isAuthSA           = !!this.sessionSysAdmin ?  true : false;
        this.isAuthLA           = !!this.sessionLeAdmin ?   true : false;
        this.isAuthLU           = !!this.sessionLeUser ?    true : false;
        this.isEventInfo        = !!this.sessionEventInfo ?  true : false;
        this.isEventShow        = !!this.sessionEventShow ?  true : false;
        this.isReserveInfo      = !!this.sessionReserveInfo ?  true : false;
        this.isMasterAuthenticationKey = !!this.sessionMasterAuthenticationKey ? true : false;
        //------------------------------------------------------------------------------------------
        let email_address       = null;
        if (!!this.sessionSysAdmin) {
          email_address = this.sessionSysAdmin.email_address;
        } else {
          if (!!this.sessionLeAdmin) {
            email_address = this.sessionLeAdmin.email_address;
          } else {
            if (!!this.sessionLeUser) {
              email_address = this.sessionLeUser.email_address;
            }
          }
        }
        //------------------------------------------------------------------------------------------
        if (!!email_address) {
          if (!this.ssPushmessage_flag) {
            this.ssPushmessage_flag = true;
            this.ssPushmessage.unsubscribe();
            this.ssPushmessage = new Subscription();
            this.ssPushmessage.add(
              this.pushmessageFireService.getDoc(email_address).subscribe(data => {
                if (!!data) {
                  let now_time      = new Date();                                                   //  現在日時
                  let now_time_msec = now_time.getTime();                                           //  現在日時：ミリ秒
                  let updated       = data.updated!.toMillis();                                     //  更新日時：ミリ秒
                  let progress      = 1 * 60 * 1000;                                                //  経過時間：１分
                  if (now_time_msec < updated + progress) {                                         //  現在日時が更新日時＋経過時間未満ならポップアップ表示
                    if (data.type == 1) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 5000,
                        panelClass: ['snackbar-success']
                      });
                    } else if (data.type == 2) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 10000,
                        panelClass: ['snackbar-warning']
                      });
                    } else if (data.type == 3) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 30000,
                        panelClass: ['snackbar-error']
                      });
                    } else {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 3000,
                        panelClass: ['snackbar-success']
                      });
                    }
                  }
                }
              })
            );
          }
        } else {
          this.ssPushmessage_flag = false;
          this.ssPushmessage.unsubscribe();
        }
        //------------------------------------------------------------------------------------------
      }
    })
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
    this.ssPushmessage.unsubscribe();
  }
  //================================================================================================
  //  ログアウト
  //================================================================================================
  logout(): void {
    this.sidenavClose.emit();
    this.sessionService.logout();
  }
  //================================================================================================
  //  言語
  //================================================================================================
  language(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('opca_language', lang);
    //----------------------------------------------------------------------------------------------
    if (lang == 'en') {
      this.currentLang = "English";
    } else {
      this.currentLang = "日本語";
    }
    //----------------------------------------------------------------------------------------------
  }
  //================================================================================================
  //  メニュー
  //================================================================================================
  menu(): void {
    this.sidenavToggle.emit();
  }
  //================================================================================================
  //  興行情報画面へ
  //================================================================================================
  gotoEventInfo(): void {
    if (!!this.sessionSysAdmin || !!this.sessionLeAdmin || !!this.sessionLeUser) {
      this.sessionService.setEventInfo(null);
      this.router.navigate(['/event-info']);
    }
  }
  //================================================================================================
  //  開催情報画面へ
  //================================================================================================
  gotoEventShow(): void {
    if (!!this.sessionSysAdmin || !!this.sessionLeAdmin || !!this.sessionLeUser) {
      this.sessionService.setEventShow(null);
      this.router.navigate(['/event-show']);
    }
  }
  //================================================================================================
  //  予約情報画面へ
  //================================================================================================
  gotoReserveInfo(): void {
    if (!!this.sessionSysAdmin || !!this.sessionLeAdmin || !!this.sessionLeUser) {
      this.sessionService.setReserveInfo(null);
      this.router.navigate(['/reserve-info', 1]);
    }
  }
  //================================================================================================
  //  認証キーマスタ画面へ
  //================================================================================================
  gotoMasterAuthenticationKey(): void {
    if (!!this.sessionSysAdmin || !!this.sessionLeAdmin || !!this.sessionLeUser) {
      this.sessionService.setMasterAuthenticationKey(null);
      this.router.navigate(['/master-authentication-key']);
    }
  }
  //================================================================================================
  //  印刷ボタン
  //================================================================================================
  onPrintScreenClick() {
    window.print();
  }
}
